export default [{
  path: '/equipes',
  component: {
    name: 'equipesBase',
    template: '<router-view />',
    meta: {
      resource: 'equipe',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'equipes',
    component: () => import('@/app-modulo/comuns/equipe/EquipeView.vue'),
    meta: {
      resource: 'equipe',
      action: 'read',
      navActiveLink: 'equipes',
      pageTitle: 'Cadastro de Equipes',
      breadcrumb: [
        {
          text: 'Equipes',
          to: { name: 'equipes' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-equipe',
    component: () => import('@/app-modulo/comuns/equipe/shared/components/cadastro/Equipe.vue'),
    meta: {
      resource: 'equipe',
      action: 'create',
      navActiveLink: 'equipes',
      pageTitle: 'Cadastro de Equipes',
      breadcrumb: [
        {
          text: 'Equipes',
          to: { name: 'equipes' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-equipe' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-equipe',
    component: () => import('@/app-modulo/comuns/equipe/shared/components/cadastro/Equipe.vue'),
    meta: {
      resource: 'equipe',
      action: 'update',
      navActiveLink: 'equipes',
      pageTitle: 'Cadastro de Equipes',
      breadcrumb: [
        {
          text: 'Equipes',
          to: { name: 'equipes' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-equipe' },
          active: true,
        },
      ],
    },
  }],
},
]
